export var BRAND = '#43EE91';
export var PRIMARY = '#143F3D';
export var PRIMARY_ALT = '#5B7978';
export var PRIMARY_DISABLED = '#B2C1C0';
export var SECONDARY = '#8EF5BD';
export var SECONDARY_ALT = '#D9FDE9';
export var BLUE = '#5654ED';
export var BLUE_ALT = '#3533DF';
export var LOGO_BACKDROP = '#43EE91'; // Not quite the same as secondary.

export var LOGO_SHADOW = '#005450'; // Not quite the same as primary.

export var GREY = '#DBE1E1';
export var GREY_ALT = '#B8C5C4';
export var GREY_FOOTER = '#323232';
export var LIGHT_GREY = '#EEF1F1';
export var LIGHT_GREEN = '#EBF4EF';
export var WHITE = '#FFFFFF';
export var BACKGROUND = '#F9F9F9';
export var BACKGROUND_CHART = '#F2F4F4';
export var BACKGROUND_ALT = '#EFF0F0';
export var ERROR = '#CB3313';
export var SUCCESS = '#4BC98D';
export var WARN = '#FBAD52';
export var DANGER = '#F67458';
export var SUCCESS_ALT = '#D9FDE9';
export var WARN_ALT = '#FFEFCA';
export var DANGER_ALT = '#FFE9E4';
export var TRANSPARENT = '#00000000';